module.exports = __webpack_public_path__ + "img/Benefit.3327cac0.png";